export default class Base {
    _apiBase = '/api';

    getResource = async (url, params) => {
        const res = await fetch(`${this._apiBase}${url}`, params);

        if (!res.ok) {
            throw new Error(`Could not fetch ${url}` +
                `, received ${res.status}`)
        }

        return await res.json();
    };
}